module.exports = __webpack_public_path__ + "product-compound-capsule-03.jpg?db7452c4d91263e05eb56f51329dd3b3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-compound-capsule-03.jpg
// module id = 100
// module chunks = 0